"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanType = void 0;
// We will be able to import this from the node client once the circular dependency issue is fixed
var PlanType;
(function (PlanType) {
    PlanType["FREE"] = "FREE";
    PlanType["PRO"] = "PRO";
    PlanType["STARTER"] = "STARTER";
    PlanType["ESSENTIAL"] = "ESSENTIAL";
    PlanType["PREMIUM"] = "PREMIUM";
    PlanType["ADVANCED"] = "ADVANCED";
    PlanType["FIXED_RATE"] = "FIXED_RATE";
    PlanType["YEARLY"] = "YEARLY";
    PlanType["PARTNERSHIP"] = "PARTNERSHIP";
    PlanType["MANAGING_PARTNER"] = "MANAGING_PARTNER";
    PlanType["PARTNER_CLIENT_FREE"] = "PARTNER_CLIENT_FREE";
})(PlanType = exports.PlanType || (exports.PlanType = {}));
//# sourceMappingURL=plan.js.map